import createReducer from '../utils/createReducer';
import actions from '../actions/confirmationPage';
import {MERCHANT_OF_RECORD} from "../utils/constants";

const initialState = {};

const actionHandlers = {
    [actions.SET_BUSINESS_MODEL_SWITCH_CHOICE](state, { payload }) {
        const advertiserBusinessModel = payload.advertiserBusinessModel;
        const preferredBusinessModel = payload.preferredBusinessModel;
        const currency = payload.currency;
        const rowMorEnabled = payload.rowMorEnabled;

        return {
            ...state,
            showBusinessModelSwitch: advertiserBusinessModel === MERCHANT_OF_RECORD.SUPPLIER
                && preferredBusinessModel !== MERCHANT_OF_RECORD.SUPPLIER
                && (rowMorEnabled || currency === 'USD')
        };
    },
};

export default createReducer(actionHandlers, initialState);
